<app-sidebar *ngIf="_coreHelper.isShowHeader"></app-sidebar>
<div [ngClass]="{'page-content-main': _coreHelper.isShowHeader == true}">
    <app-header *ngIf="_coreHelper.isShowHeader"></app-header>
    <div [ngClass]="{'page-content': _coreHelper.isShowHeader == true}">
        <router-outlet></router-outlet>
    </div>
</div>

<div class="loader-spinner-section">
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.9)" name="global" size="medium" type="square-jelly-box" [fullScreen]="true"><img src="../assets/img/loader-white.gif" alt="Loading"></ngx-spinner>
</div>



<!-- Please Confirm Popup Start -->
<kendo-dialog title="Please Confirm" *ngIf="onBreak" (close)="onBreak=true"
    class="kendo-modal modal-sm text-center" >
    <div class="common-popup-alert">
        <h6 class="text-center">Would you like to continue working ?</h6>
        <kendo-dialog-actions class="d-block text-center">
            <button kendoButton class="btn btn-primary btn-sm" (click)="continueWorkingAfterBreak()">Yes</button>
            <button kendoButton class="btn btn-cancel btn-sm" (click)="onBreak=true">Continue On Break</button>
        </kendo-dialog-actions>
    </div>
</kendo-dialog>
<!-- Please Confirm Popup End -->
